import { IModalControlItem } from 'components/modal/modules/controls/IModalControlItem';
import UIModalDuck from 'stores/ducks/ui/UIModal.duck';
import { store } from 'stores/store.js';

/**
 * Used to open modal outside of React Components
 *
 * @param content React Component, HTML Element(s), string....
 * @param title Desired Title of Modal
 * @param controls Array of controls
 */
export function openModal(
  content: any,
  title?: string,
  controls?: IModalControlItem[]
): void {
  store.dispatch(UIModalDuck.openModal(content, title, controls));
}

/**
 * Used to close modal outside of React Components
 */
export function closeModal(): void {
  store.dispatch(UIModalDuck.closeModal());
}



// WEBPACK FOOTER //
// ./src/components/modal/modules/dispatcher/methods.ts